var ColumnType;
(function (ColumnType) {
    ColumnType["CHECKBOX"] = "checkbox";
    ColumnType["CHEVRON"] = "chevron";
    ColumnType["DEFAULT"] = "default";
    ColumnType["DYNAMIC"] = "dynamic";
    ColumnType["SUPERSCRIPTION"] = "superscription";
    ColumnType["SUPERSCRIPTION_BAR"] = "superscription_bar";
})(ColumnType || (ColumnType = {}));
const DEFAULT_ACTION_COLUMN_WIDTH = 100;
const DEFAULT_CHECKBOX_COLUMN_WIDTH = 55;
const DEFAULT_SUPERSCRIPTION_COLUMN_WIDTH = 8;
const DEFAULT_TABLE_COLUMN_WIDTH = 55;
const DEFAULT_TREE_GROUP_LABEL_COLUMN_WIDTH = 150;
const RSTABLE_DEFAULT_COLUMN_SIZE = 100;
export { ColumnType, DEFAULT_ACTION_COLUMN_WIDTH, DEFAULT_CHECKBOX_COLUMN_WIDTH, DEFAULT_SUPERSCRIPTION_COLUMN_WIDTH, DEFAULT_TABLE_COLUMN_WIDTH, DEFAULT_TREE_GROUP_LABEL_COLUMN_WIDTH, RSTABLE_DEFAULT_COLUMN_SIZE, };
//# sourceMappingURL=table-column-constants.js.map